import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Base from '@/components/Base'
import Help from '@/components/Help'
// import NProgress from 'nprogress/nprogress'

import Header from '@/components/Header'
import License from '@/components/License'
import UpdateLicense from '@/components/UpdateLicense'
import UpdateMatureLicense from '@/components/UpdateMatureLicense'
import CopyMatureLicense from '@/components/CopyMatureLicense'
import Detail from '@/components/Detail'
import MatureDetail from '@/components/MatureDetail'
import Breadcrumb from '@/components/Breadcrumb'
import LicenseStatus from '@/components/status/LicenseStatus'
import Alert from '@/components/Alert'
import Layer from '@/components/dialoglayer/Layer'

Vue.component('z-header', Header)
Vue.component('z-breadcrumb', Breadcrumb)
Vue.component('z-license-status', LicenseStatus)
Vue.component('z-alert', Alert)
Vue.component('z-layer', Layer)

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '微博广告资质中心'
    }
  }, {
    path: '/qulification/base/:package_id',
    name: 'update_base',
    component: Base,
    meta: {
      title: '微博广告资质中心-修改资质证明'
    }
  }, {
    path: '/qulification/base',
    name: 'base',
    component: Base,
    meta: {
      title: '微博广告资质中心-添加资质证明'
    }
  }, {
    path: '/qulification/license/:package_id',
    name: 'license',
    component: License,
    meta: {
      title: '微博广告资质中心-添加资质证明'
    }
  }, {
    path: '/qulification/:package_id',
    name: 'package_id',
    component: Detail,
    meta: {
      title: '微博广告资质中心-查看资质详情'
    }
  }, {
    path: '/qulification/license/update/:package_id',
    name: 'update_license',
    component: UpdateLicense,
    meta: {
      title: '微博广告资质中心-更新资质证明'
    }
  }, {
    path: '/qulification/mature/:package_id',
    name: 'mature_package_id',
    component: MatureDetail,
    meta: {
      title: '微博广告资质中心-查看资质详情'
    }
  }, {
    path: '/qulification/mature/license/update/:package_id',
    name: 'update_mature_license',
    component: UpdateMatureLicense,
    meta: {
      title: '微博广告资质中心-更新资质证明'
    }
  }, {
    path: '/qulification/mature/license/copy/:package_id',
    name: 'copy_mature_license',
    component: CopyMatureLicense,
    meta: {
      title: '微博广告资质中心-复制资质证明'
    }
  }, {
    path: '/help',
    name: 'help',
    component: Help,
    meta: {
      title: '微博广告资质中心-帮助中心'
    }
  }]
})

router.beforeEach((routeTo, routeFrom, next) => {
  if (routeTo.meta.title) {
    document.title = routeTo.meta.title
  }
  if (window.location.host.includes('brand')) {
    // let loginStaffNumber = routeFrom.query['loginStaffNumber'] || routeTo.query['loginStaffNumber']
    // let clientNumber = routeFrom.query['clientNumber'] || routeTo.query['clientNumber']
    // let replaceStaffNumber = routeFrom.query['replaceStaffNumber'] || routeTo.query['replaceStaffNumber']
    // let timestamp = routeFrom.query['timestamp'] || routeTo.query['timestamp']
    // let apiSign = routeFrom.query['apiSign'] || routeTo.query['apiSign']
    let loginParam = routeFrom.query['loginParam'] || routeTo.query['loginParam']
    // if (loginStaffNumber) {
    //   routeTo.query['loginStaffNumber'] = loginStaffNumber
    // }
    // if (clientNumber) {
    //   routeTo.query['clientNumber'] = clientNumber
    // }
    // if (replaceStaffNumber) {
    //   routeTo.query['replaceStaffNumber'] = replaceStaffNumber
    // }
    // if (timestamp) {
    //   routeTo.query['timestamp'] = timestamp
    // }
    // if (apiSign) {
    //   routeTo.query['apiSign'] = apiSign
    // }
    if (loginParam) {
      routeTo.query['loginParam'] = loginParam
      next()
    } else {
      // 没有对应参数
    }
  } else {
    let customerId = routeFrom.query['customer_id'] || routeTo.query['customer_id']
    let clientId = routeFrom.query['clientId'] || routeTo.query['clientId']
    if (customerId) {
      routeTo.query['customer_id'] = customerId
    }
    if (clientId) {
      routeTo.query['clientId'] = clientId
    }
    let user = window.sso_weiboad.getSinaCookie(true)
    if (user === null && process.env.NODE_ENV !== 'development') {
      if (!clientId) {
        window.location.href = '//weibo.com/login.php?url=' + encodeURIComponent(window.location.href)
      } else {
        next()
      }
    } else {
      if (user && customerId === user.uid) {
        routeTo.query['customer_id'] = undefined
      }
      next()
    }
  }
})

// // When each route is finished evaluating...
router.afterEach((routeTo, routeFrom) => {
  // Complete the animation of the route progress bar.
  // console.log('route leave', this)
  // NProgress.done()
  window.scrollTo(0, 0)
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js